import ListView from "./ListView/ListView";
import DetailView from "./DetailView";

const HistoryFertilization = () => <p>History Fertilization</p>;

HistoryFertilization.ListView = ListView;
HistoryFertilization.DetailView = DetailView;
export default HistoryFertilization;
